<template>
  <SectionLayout
    class="calculator"
    :title="title"
    :subtitle="subtitle"
    bg-theme="primary-invert"
    :steps="3"
    :current-step="currentStep"
    :apply-main-banner-bg="currentStep === 1"

  >
    <Step1
      v-if="currentStep === 1"
      @step-one-submit="stepOneHandler"
      :result-id="resultId"
      :bank-string-code="bankStringCode"
      @update-result-id="updateResultId"
    />
    <Step2
      v-if="currentStep === 2"
      :form-data="formData"
      :tariffs-sum="tariffsSum"
      :prem-sum-go="getPremSumGo"
      :result-id="resultId"
      :tariff-go="tariffGo"
      :use-titul="useTitul"
      @tariff-chosen="handleTariff"
      @change-tariff-go="handleTariffGo"
      @change-use-titul="handleUseTitul"
      @mounted="mountedHandler"
      @show-request-call-modal="showRequestCallModalHandler"
    />
    <Step3
      v-if="currentStep === 3"
      ref="stepThree"
      :form-data="formData"
      :prepare-data="prepareStepOneData.data"
      :tariff-type="tariffType"
      :result-id="resultId"
      :uralsib-id="uralsibId"
      :use-titul="useTitul"
      @prev-step="prevStep()"
      @step-three-submit="stepThreeSubmitHandler"
      @update-result-id="updateResultId"
    />
    <ModalRequestCall
      :title="requestCallTitle"
      :text="requestCallText"
      :visible="showRequestCallModal"
      :form-data="prepareStepThreeData"
      modal-width="719px"
      @close="closeRequestCallModal"
      @request-call-submit="requestCallSubmitHandler"
    />
      <ModalError
          title="Ошибка"
          :text="showErrorModalText"
          :visible="showErrorModal"
          modal-width="719px"
          @close="closeErrorModal"
      />
    <ModalFirstStep
      :visible="showFirstStepModel"
      :query-data="firstModalRequestData"
      modal-width="750px"
      @close="closeFirstStepModal"
    />
    <ModalRequestCallSuccess
      title="Ваша заявка отправлена"
      :text="requestCallText"
      :visible="showRequestCallSuccessModal"
      modal-width="719px"
      @close="closeRequestCallSuccessModal"
    />
    <ModalPriceChanged
      :visible="showPriceChangedModal"
      modal-width="719px"
      :cost-text="`Была: ${this.allInsuranceCost}, Стала ${this.fullCalculateSumm}`"
      :warning-text="getWarningText()"
      @close="showPriceChangedModal = false"
      @submit="modalPriceChangedSubmitHandler"
    />
    <template v-if="currentStep !== 1 && tariffs && tariffs.length" #aside-content>
      <ResultCard
        :all-insurance-cost="allInsuranceCostString"
        :prepare-data="prepareStepOneData.data"
        :bank-code="formData && formData.bank ? formData.bank.code : ''"
        :use-titul="useTitul"
        :current-step="currentStep"
        @coupon-discount="handleDiscount"
      />
    </template>
    <template #actions>
      <div
        v-if="currentStep < 3"
        class="calculator__actions"
        :class="{ 'calculator__actions--step1': currentStep === 1 }">        <div v-if="currentStep === 2" class="calculator__actions-row">
          <BaseButton
            class="calculator__prev-step"
            text="Назад"
            @click.native="prevStep"
          />
          <BaseButton
            class="calculator__submit"
            text="Продолжить"
            :disabled="!isTariffSelected"
            @click.native="stepTwoSubmitHandler"
          />
        </div>
        <button
          class="calculator__call"
          type="button"
          @click="showRequestCallModalHandler"
        >
          Оставить заявку
        </button>
      </div>
      <div v-if="currentStep === 3" class="calculator__actions">
        <div class="calculator__actions-row">
          <BaseButton
            class="calculator__prev-step"
            text="Назад"
            @click.native="prevStep"
          />
          <BaseButton
            class="calculator__submit"
            text="Перейти к оплате"
            theme="primary-invert"
            @click.native="stepThreeSubmitHandler"
          />
        </div>
      </div>
    </template>
  </SectionLayout>
</template>
<script>
import {calculatorEipotekaPost, calculatorEipoteka} from '@/api/routes/calculator-eipoteka';
import SectionLayout from '@/components/layouts/SectionLayout';
import TabList from '@/components/shared/tabs/TabList';
import Step1 from '@/components/pages/index/InsuranceProcess/Step1';
import Step2 from '@/components/pages/index/InsuranceProcess/Step2';
import Step3 from '@/components/pages/index/InsuranceProcess/Step3';
import ModalRequestCall from '@/components/modals/ModalRequestCall';
import ModalError from '@/components/modals/ModalError';
import ModalFirstStep from '@/components/modals/ModalFirstStep';
import ModalRequestCallSuccess from '@/components/modals/ModalRequestCallSuccess';
import ModalPriceChanged from '@/components/modals/ModalPriceChanged';
import ResultCard from '@/components/pages/index/InsuranceProcess/ResultCard';
import BaseButton from "@/components/ui/BaseButton";
import {TARIFFS_GO} from "@/consts";
import { submitRequestCall } from '@/api/request-service';
import Cookies from 'js-cookie';

const HEADERS = {
  "Set-Cookie": document.cookie,
}
export default {
  name: 'InsuranceProcess',
  components: {
    BaseButton,
    ResultCard,
    ModalRequestCall,
      ModalError,
    ModalFirstStep,
    ModalRequestCallSuccess,
    ModalPriceChanged,
    SectionLayout,
    TabList,
    Step1,
    Step2,
    Step3,
  },
  inject: ['setShowGlobalSpinner'],
  data() {
    return {
      currentStep: 1,
      stepHeaders: {
        '1': {
          title: 'Ипотечное страхование онлайн',
          subtitle: 'Онлайн калькулятор страхования ипотеки, рассчитайте стоимость ипотечного страхования и оформите полис для квартиры или страхование жизни и здоровья онлайн',
        },
        '2': {
          title: 'Результаты расчета',
          subtitle: 'Выберите вариант или несколько из представленных',
        },
      },
      showRequestCallModal: false,
      showErrorModal: false,
      showErrorModalText: 'Для заключения договора обратитесь в офис',
      showFirstStepModel: false,
      showRequestCallSuccessModal: false,
      showPriceChangedModal: false,
      isRequestCall: false,
      tariffsSum: null,
      tariffs: [],
      formData: null,
      prepareData: null,
      prepareStepOneData: null,
      prepareStepThreeData: null,
      tariffType: '',
      mockTariffsSum: {"sumPremLife": 1323.12, "sumPremProperty": 1175.61},
      mockFormData: {
        "bankId": "E3B220D9-4F21-4086-9785-5C0E6412EE95",
        "balanceSum": 100000,
        "regionId": "5345345",
        "birthday": "04.04.2006",
        "sex": "M",
        "objectTypeId": "111",
        "dateCredit": ""
      },
      sessionData: null,
      twoStepSessionData: {
        tariffs: {
          life: false,
          property: false,
        }
      },
      fullCalculateSumm: 0,
      promotionalCode: '',
      discountPercent: 0,
      resultId: 0,
      uralsibId: '',
      tariffGo: null,
      useTitul: false,
      premGo: 0,
      sumGo: 0,
      firstModalRequestData: {},
      subId: '',
      clickId: '',
      saleChannelIsn: '',
      curatorIsn: '',
      agentIsn: '',
      bankStringCode: '',
      advertiseUid: '',
      leadsUid: '',
      utmCampaign: '',
      utmContent: '',
      utmMedium: '',
      utmSource: '',
      utmTerm: '',
      workleUid: '',
      subAgent: '',
    }
  },
  methods: {
    getAdmitadUid() {
      let admitadUidValue = this.$route.query?.admitad_uid ? this.$route.query.admitad_uid : '';
      if (!admitadUidValue) {
        admitadUidValue = Cookies.get('admitad_uid');
      }

      return admitadUidValue ?? '';
    },
    setAdmitadCookie() {
      const daysStore = 90;
      const uidCookieName = 'admitad_uid';

      let admitadUidValue = this.$route.query?.admitad_uid ? this.$route.query.admitad_uid : '';

      if (!admitadUidValue) {
        return;
      }

      const period = daysStore * 60 * 60 * 24 * 1000;
      const expiresDate = new Date((period)+ + new Date);
      const cookieString = uidCookieName + '=' + admitadUidValue + '; path=/; expires=' + expiresDate.toGMTString();

      document.cookie = cookieString;
      document.cookie = cookieString + '; domain=.' + location.host;
    },

    handleTariffGo(value) {
      if (!value) {
        this.premGo = 0;
        this.sumGo = 0;
        this.tariffGo = null;

        return;
      }

      if (!TARIFFS_GO[value]) {
        this.premGo = 0;
        this.sumGo = 0;
        this.tariffGo = null;

        return;
      }

      this.premGo = TARIFFS_GO[value].psum;
      this.sumGo = TARIFFS_GO[value].isum;
      this.tariffGo = value;
    },
    handleUseTitul(value) {
      if (!value) {
        this.useTitul = false
        return;
      }

      this.useTitul = true
    },
    updateResultId(resultId) {
      this.resultId = resultId;
    },
    prevStep() {
      this.currentStep--;
    },
    nextStep() {
      this.currentStep++;
    },
    async stepOneHandler(formData, stepOneSessionData, withNextStep = true) {
      this.setShowGlobalSpinner(true);
      this.sessionData = stepOneSessionData;
      this.formData = formData;
      this.prepareStepOneData = this.preparePreCalculateData(formData);
      this.prepareStepOneData.data.resultId = this.resultId;
      try {
        this.firstModalRequestData = {};
        if (this.formData?.bank?.bankId) {
          this.firstModalRequestData.bankId = this.formData.bank.bankId;
        }

        if (this.formData?.birth_date) {
          this.firstModalRequestData.birthDate = this.formData.birth_date;
        }

        if (this.formData?.gender) {
          this.firstModalRequestData.gender = this.formData.gender;
        }

        if (this.formData?.objectId) {
          this.firstModalRequestData.objectId = this.formData.objectId;
        }

        if (this.formData?.credit_balance) {
          this.firstModalRequestData.creditBalance = this.formData.credit_balance;
        }


        let promiseCalculate = calculatorEipotekaPost('preCalculateAction', this.prepareStepOneData);
        const _this = this;
        promiseCalculate.then(function (resultProm) {
          const result = resultProm;
          _this.resultId = resultProm.resultId;
          _this.setOneStepSessionData(formData);
          _this.resultId = result.resultId;
          if (!result.result) {
            _this.setShowGlobalSpinner(false);
            _this.showFirstStepModel = true;
            return;
          }

          _this.tariffsSum = {
            sumPremLife: result.response.sumPremLife,
            sumPremProperty: result.response.sumPremProperty,
            sumPremTitul: result.response.sumPremTitul
          };
          _this.setShowGlobalSpinner(false);

          if (withNextStep) {
            _this.nextStep();
          }

          if (_this.currentStep === 3) {
            _this.tariffs.map((card) => {
              if (card.tariff === 'property' && result.response.sumPremProperty) {
                card.sumPrem = result.response.sumPremProperty;
                card.cardPrice = result.response.sumPremProperty;
              }

              if (card.tariff === 'life' && result.response.sumPremLife) {
                card.sumPrem = result.response.sumPremLife;
                card.cardPrice = result.response.sumPremLife;
              }
            });
          }
        });
      } catch (e) {
        console.log(e)
        this.showFirstStepModel = true;
        this.setShowGlobalSpinner(false);
      }
    },
    stepTwoSubmitHandler() {
      this.tariffs.forEach((tariff, index) => {
        if (tariff.isSelected) {
          if (index === 1 && this.tariffType) {
            this.tariffType = 'lifeAndProperty';
          } else {
            this.tariffType = tariff.tariff;
          }
        }
      });
      this.setTwoStepSessionData();
      this.nextStep();
    },
    async stepThreeSubmitHandler() {
      this.setShowGlobalSpinner(true);
      const formEl = this.$refs.stepThree.$refs.propertyFormRef;
      let isValidForm = false;
      formEl.validate(valid => {
        isValidForm = valid;
      });
      if (!isValidForm) {
        this.setShowGlobalSpinner(false);
        return;
      }
      const formData = this.$refs.stepThree.$data.propertyForm;
      this.prepareStepThreeData = this.prepareFullCalculateData(formData);
      this.prepareStepThreeData.data.resultId = this.resultId;
      this.prepareStepThreeData.data.useTitul = this.useTitul;
      try {
        this.setThreeStepSessionData(formData);
        const fullCalculateResponseContent = await calculatorEipotekaPost('fullCalculateAction', this.prepareStepThreeData);

          if (
              fullCalculateResponseContent?.result
              && fullCalculateResponseContent?.response?.block
              && !fullCalculateResponseContent?.response?.result
          ) {
              this.setShowGlobalSpinner(false);
              if (fullCalculateResponseContent?.response?.errors[0]) {
                this.showErrorModalText = fullCalculateResponseContent.response?.errors[0];
              }

              this.showErrorModal = true;
              return;
          }

        if (!fullCalculateResponseContent.result || !!!fullCalculateResponseContent.response.elementId) {
          this.setShowGlobalSpinner(false);
          this.showRequestCallModal = true;
          return;
        }
        this.prepareStepThreeData.data.elementId = fullCalculateResponseContent.response.elementId;
        this.resultId = 0;
        this.propertyDisabled = !!fullCalculateResponseContent.response?.propertyDisabled;
        this.lifeDisabled = !!fullCalculateResponseContent.response?.lifeDisabled;
        if (!!this.tariffsSum.sumPremProperty && !!!this.tariffsSum.sumPremLife && this.propertyDisabled) {
          this.showRequestCallModal = true;
          this.setShowGlobalSpinner(false);
          return;
        }
        if (!!this.tariffsSum.sumPremLife && !!!this.tariffsSum.sumPremProperty && this.lifeDisabled) {
          this.showRequestCallModal = true;
          this.setShowGlobalSpinner(false);
          return;
        }
        this.fullCalculateSumm = this.getFullCalculateSumm(fullCalculateResponseContent);
        if (
          parseFloat(this.allInsuranceCost) === parseFloat(this.fullCalculateSumm)
          && !this.propertyDisabled
          && !this.lifeDisabled) {
          await this.getPaymentUrlAction();
          this.setShowGlobalSpinner(false);
          return;
        }
        this.showPriceChangedModal = true;
        this.setShowGlobalSpinner(false);
      } catch (e) {
        this.showRequestCallModal = true;
        this.setShowGlobalSpinner(false);
        console.error(e)
      }
    },
    async setOneStepSessionData(formData) {
      const dataForSetSessionData = {
        data: {
          ...this.sessionData,
          stepOne: formData,
          resultId: this.resultId,
        }
      }
      await calculatorEipotekaPost('setSessionData', dataForSetSessionData, HEADERS);
    },
    async setTwoStepSessionData() {
      this.tariffs.forEach((tariff) => {
        this.twoStepSessionData.tariffs[tariff.tariff] = tariff.isSelected
      });
      const dataForSetSessionData = {
        data: {
          ...this.sessionData,
          stepTwo: this.twoStepSessionData,
          resultId: this.resultId,
        }
      };
      await calculatorEipotekaPost('setSessionData', dataForSetSessionData, HEADERS);
    },
    async setThreeStepSessionData(formData) {
      const deletedKeys = ['personalPolicy', 'personalPolicy2','personalPolicy3','personalPolicy4','personalPolicy5','personalPolicy6','personalPolicy7','mortgageInsuranceAgreement', 'policeAgreement']
      const currectObject = {};
      Object.entries(formData).forEach(([key, value]) => {
        if (!deletedKeys.includes(key)) {
          currectObject[key] = value;
        }
      })
      const dataForSetSessionData = {
        data: {
          ...this.sessionData,
          stepThree: currectObject,
          resultId: this.resultId,
        },
      };
      await calculatorEipotekaPost('setSessionData', dataForSetSessionData, HEADERS);
    },
    getFullCalculateSumm(fullCalculateResponseContent) {
      let summ = 0;
      if (!!fullCalculateResponseContent.response?.sumFinalProperty) {
        summ += fullCalculateResponseContent.response.sumFinalProperty;
      }
      if (!!fullCalculateResponseContent.response?.sumFinalLife) {
        summ += fullCalculateResponseContent.response.sumFinalLife;
      }
      if (!!fullCalculateResponseContent.response?.sumFinalGo) {
        summ += fullCalculateResponseContent.response.sumFinalGo;
      }

      summ = parseFloat(summ);
      summ = summ.toFixed(2);

      return summ;
    },
    preparePreCalculateData(data) {
      return {
        data: {
          bankId: data.bank.bankId,
          bankName: data.bank.name,
          balanceSum: Number(data.credit_balance.replace(/ /g, '')),
          birthday: data.birth_date,
          sex: data.gender,
          objectTypeId: data.objectId,
          dateCredit: data.credit_date,
          coupon: this.promotionalCode ?? '',
          admitadUid: this.getAdmitadUid(),
          clickId: this.clickId,
          subId: this.subId,
          saleChannelIsn: this.saleChannelIsn,
          curatorIsn: this.curatorIsn,
          agentIsn: this.agentIsn,
          bankStringCode: this.bankStringCode,
          advertiseUid: this.advertiseUid,
          utmCampaign: this.utmCampaign,
          utmContent: this.utmContent,
          utmMedium: this.utmMedium,
          utmSource: this.utmSource,
          utmTerm: this.utmTerm,
          workleUid: this.workleUid,
          subAgent: this.subAgent,
        }
      }
    },
    prepareFullCalculateData(data) {
      const {data: prepareStepOneData} = this.prepareStepOneData;
      const fullNameWords = data.fio.split(' ');
      return {
        data: {
          ...prepareStepOneData,
          isSetProperty: !!this.tariffsSum.sumPremProperty && (this.tariffType === 'lifeAndProperty' || this.tariffType === 'property'),
          isSetLife: !!this.tariffsSum.sumPremLife && (this.tariffType === 'lifeAndProperty' || this.tariffType === 'life'),
          lastName: fullNameWords[0] || '',
          name: fullNameWords[1] || '',
          secondName: fullNameWords[2] || '',
          dateCredit: data.credit_date,
          email: data.email,
          phone: data.phone,
          passport: data.passportNumber,
          passportIssueDate: data.passportDate,
          passportDepartment: data.departmentCode,
          passportIssuedBy: data.issuedBy,
          addressRegistration: data.registrationAddress,
          houseRegistration: data.apartmentNumber,
          agreentNumber: data.loanAgreementNumber,
          manualAnnuity: Number(data.manualAnnuity.replace(/ /g, '')),
          agreentNumberDate: data.dateLoanAgreement,
          agreentStartDate: data.dateLoanStart,
          addressObject: data.registrationObjectAddress,
          houseObject: data.registrationObjectFlat,
          objectDate: data.yearHouseBuilt,
          objectFloorNumber: data.numberFloorsHouse,
          objectArea: data.square,
          wallMaterial: data.wallMaterials,
          typeHomePurchase: data.typeHomePurchase,
          gasification: 'тест',
          disclaimer: 'тест',
          height: data.height,
          weight: data.weight,
          highPressure: data.highPressure,
          lowPressure: data.lowPressure,
          fiasIdRegistrationAddress: data.registrationAddressKladr,
          fiasHouseIdRegistrationAddress: data.registrationKladrHouse,
          fiasIdObjectAddress: data.registrationObjectAddressKladr,
          fiasHouseIdObjectAddress: data.registrationObjectKladrHouse,
          discountPercent: 0,
          elementId: this.elementId,
          premGo: this.premGo,
          sumGo: this.sumGo,

          objectStreet: data.objectStreet,
          objectHome: data.objectHome,
          objectIndex: data.objectIndex,
          objectStructure: data.objectStructure,
          objectFiasGuid: data.objectFiasGuid,
          objectFiasHouseGuid: data.objectFiasHouseGuid,

          admitadUid: this.getAdmitadUid(),

          clickId: this.clickId,
          subId: this.subId,
          saleChannelIsn: this.saleChannelIsn,
          curatorIsn: this.curatorIsn,
          agentIsn: this.agentIsn,

          bankStringCode: this.bankStringCode,
          advertiseUid: this.advertiseUid,
          leadsUid: this.leadsUid,
          utmCampaign: this.utmCampaign,
          utmContent: this.utmContent,
          utmMedium: this.utmMedium,
          utmSource: this.utmSource,
          utmTerm: this.utmTerm,
          workleUid: this.workleUid,
          subAgent: this.subAgent,
        }
      }
    },
      async requestCallSubmitHandler(formData) {
      let userFormData = {};
      if (this.currentStep === 1 && this.formData && this.formData.bank) {
        userFormData = this.preparePreCalculateData(this.formData);
      } else if (this.currentStep === 2 && this.formData && this.formData.bank) {
        userFormData = this.preparePreCalculateData(this.formData);
        userFormData.data.stepTwo = this.twoStepSessionData; 
      } else if (this.currentStep === 3 && this.$refs?.stepThree?.propertyForm) {
        userFormData = this.prepareFullCalculateData(this.$refs?.stepThree?.propertyForm)
      }
      userFormData.requestData = formData;
      userFormData.resultId = this.resultId;
      userFormData.coupon = this.promotionalCode;
      userFormData.useTitul = this.useTitul;
      const requestResponse = await calculatorEipotekaPost('createRequest', userFormData);
      this.closeRequestCallModal();
      this.showRequestCallModalSuccessHandler();
    },
    async modalPriceChangedSubmitHandler() {
      this.setShowGlobalSpinner(true);
      await this.getPaymentUrlAction();
      this.setShowGlobalSpinner(true);
    },
    async getPaymentUrlAction() {
      try {
        const paymentUrlResponse = await calculatorEipotekaPost('getPaymentUrlAction', this.prepareStepThreeData);
        const paymentUrlContent = paymentUrlResponse;
        if (!paymentUrlContent.result || !!!paymentUrlContent.response) {
          return;
        }
        window.location.href = paymentUrlContent.response;
      } catch (e) {
        console.error(e)
      }
    },
    showRequestCallModalHandler() {
      this.isRequestCall = true;
      this.showRequestCallModal = true;
    },
    showRequestCallModalSuccessHandler() {
      this.showRequestCallSuccessModal = true;
    },
    closeRequestCallModal() {
      this.isRequestCall = false;
      this.showRequestCallModal = false
    },
    closeFirstStepModal() {
      this.isRequestCall = false;
      this.showFirstStepModel = false
    },
      closeErrorModal() {
      this.showErrorModal = false
    },
    closeRequestCallSuccessModal() {
      this.showRequestCallSuccessModal = false
    },
    mountedHandler(tariffs) {
      this.resetTariffs(tariffs);
    },
    handleTariff(tariffs) {
      this.resetTariffs(tariffs);
    },
    handleDiscount(data) {
      this.promotionalCode = data.promotionalCode;
      this.discountPercent = data.discountPercent;
      this.stepOneHandler(this.formData, this.sessionData, false);
    },
    resetTariffs(tariffs) {
      this.tariffs = tariffs;
      this.tariffType = '';
    },
    getWarningText() {
      if (!this.propertyDisabled && !this.lifeDisabled) {
        return '';
      }
      if (this.propertyDisabled) {
        return 'Невозможно оформить страхование имущества';
      }
      if (this.lifeDisabled) {
        return 'Невозможно оформить страхование жизни';
      }
    },
  },
  computed: {
    getPremSumGo() {
      let prem = this.premGo - (this.premGo * this.discountPercent / 100);
      return (Math.round(prem * 10) / 10) ?? 0;
    },
    title() {
      if (this.currentStep !== 3) {
        return this.stepHeaders[this.currentStep.toString()]?.title
      }
      let object;
      if (this.tariffType === 'life') {
        object = 'жизни';
      } else if (this.tariffType === 'property') {
        object = 'недвижимости';
      } else {
        object = 'недвижимости и здоровья';
      }
      return `Оформление полиса для ${object}`
    },
    subtitle() {
      return this.stepHeaders[this.currentStep.toString()]?.subtitle
    },
    requestCallTitle() {
      return this.isRequestCall
        ? 'Заказать звонок'
        : 'Невозможно произвести расчет'
    },
    requestCallText() {
      return this.isRequestCall
        ? 'Оставьте контактные данные и наши менеджеры свяжутся с Вами!'
        : 'В данный момент сервис недоступен для расчета онлайн, но вы можете оставить заявку, наши менеджеры с вами свяжутся'
    },
    isTariffSelected() {
      return !!this.tariffs.find((tariff) => tariff.isSelected)
    },
    allInsuranceCost() {
      const summ = this.tariffs.reduce((acc, current) => {
        const cost = (current.isSelected) ? current.sumPrem : 0;
        return acc + cost;
      }, 0);
      return summ ? summ.toFixed(2) : 0;
    },
    allInsuranceCostString() {
      return `${this.allInsuranceCost}&nbsp;₽`;
    },
  },
  async mounted() {
    this.setAdmitadCookie();

    this.subId = this.$route.query?.sub_id ?? (this.$route.query?.SUB_ID ?? '');
    this.clickId = this.$route.query?.click_id ?? (this.$route.query?.CLICK_ID ?? '');
    this.saleChannelIsn = this.$route.query['sales-channel'] ?? '';
    this.curatorIsn = this.$route.query['mentor'] ?? '';
    this.agentIsn = this.$route.query['agent'] ?? '';

    this.bankStringCode = this.$route.query['bank'] ?? '';
    this.advertiseUid = this.$route.query?.advertise_uid ?? (this.$route.query?.ADVERTISE_UID ?? '');
    this.leadsUid = this.$route.query?.leads_uid ?? (this.$route.query?.LEADS_UID ?? '');
    this.utmCampaign = this.$route.query?.utm_campaign ?? (this.$route.query?.UTM_CAMPAIGN ?? '');
    this.utmContent = this.$route.query?.utm_content ?? (this.$route.query?.UTM_CONTENT ?? '');
    this.utmMedium = this.$route.query?.utm_medium ?? (this.$route.query?.UTM_MEDIUM ?? '');
    this.utmSource = this.$route.query?.utm_source ?? (this.$route.query?.UTM_SOURCE ?? '');
    this.utmTerm = this.$route.query?.utm_term ?? (this.$route.query?.UTM_TERM ?? '');
    this.workleUid = this.$route.query?.workle_uid ?? (this.$route.query?.WORKLE_UID ?? '');
    this.subAgent = this.$route.query['sub-agent'] ?? (this.$route.query['SUB_AGENT'] ?? '');


    const uralsibId = await calculatorEipoteka('getUralsibIdAction');
    if (uralsibId) {
      this.uralsibId = uralsibId;
    }
  },
}
</script>
<style lang="scss" scoped>
.calculator {
  
  &__actions {
    text-align: right;
    @media #{$screen-small} {
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
    }
    &--step1 {
      text-align: right;
      max-width: 700px;
      .calculator__call {
        width: 50%;
        padding: 0;
      }
    }

    &-row {
      display: flex;
      justify-content: flex-end;
      @media #{$screen-small} {
        flex-direction: column-reverse;
        width: 100%;
      }
    }
  }

  &__prev-step {
    color: rgba(#3d3d3d, 0.5);
    border: none;
    background-color: transparent;

    &:focus,
    &:hover {
      color: rgba(#3d3d3d, 0.5);
      border: none;
      background-color: transparent;
    }

    &:not(:last-child) {
      margin-right: rem(24);
      @media #{$screen-small} {
        margin: rem(16) 0 0 0;
      }
    }
  }

  &__call {
    &:hover {
      text-decoration: underline;
    }
    @include text-props(16px, 24px);
    width: rem(163);
    cursor: pointer;
    text-align: center;
    color: $bondi-blue;
    border: none;
    background-color: transparent;

    &:not(:first-child) {
      margin-top: rem(16);
      @media #{$screen-small} {
        margin: 0 0 rem(16) 0;
      }
    }
  }

  :deep(.section-layout__title) {
    max-width: rem(640);
    @media #{$screen-big} {
      max-width: rem(450);
    }
  }
}
</style>
